import { render, staticRenderFns } from "./FormAggregateFone.vue?vue&type=template&id=f8965206"
import script from "./FormAggregateFone.vue?vue&type=script&lang=js"
export * from "./FormAggregateFone.vue?vue&type=script&lang=js"
import style0 from "./FormAggregateFone.vue?vue&type=style&index=0&id=f8965206&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports